import { SVGPropsIcon } from 'src/types';

export const Wallet = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className="w-6 h-6"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M19.2 2.1333H4.8C2.148 2.1333 0 4.2813 0 6.9333V16.5333C0 19.1853 2.148 21.3333 4.8 21.3333H19.2C21.852 21.3333 24 19.1853 24 16.5333V6.9333C24 4.2813 21.852 2.1333 19.2 2.1333ZM16.968 13.8573C16.68 14.0973 16.284 14.1933 15.912 14.0973L2.58 10.8333C2.94 9.9573 3.792 9.3333 4.8 9.3333H19.2C20.004 9.3333 20.712 9.7413 21.156 10.3413L16.968 13.8573ZM4.8 4.5333H19.2C20.52 4.5333 21.6 5.6133 21.6 6.9333V7.5933C20.892 7.1853 20.076 6.9333 19.2 6.9333H4.8C3.924 6.9333 3.108 7.1853 2.4 7.5933V6.9333C2.4 5.6133 3.48 4.5333 4.8 4.5333Z"
        fill="#150E30"
      />
    </svg>
  );
};
